module.exports = __webpack_public_path__ + "static/media/project-2.adc407de.jpg";